export const QUERY_KEYS = {
  IMPRESSIONS_DISTRIBUTION: 'impressions-distribution',
  TOP_CHARTS: 'topChars',
  AI_SUMMARY: 'ai-summary',
} as const;
